
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import clarityService from './services/clarityService';

// Load Stripe
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY || 'pk_test_51Qoix3KoczsQOoB4YvsPWn5b0U6WPBfcht2GXDDbRRjilxgNbfaoQx12jiOeV1WXP3W2ny7wOpy25UUsv08SrFxJ00hwEI4tlJ');

// Initialize app with optional mock service worker and analytics
async function initializeApp() {
  // Initialize Microsoft Clarity if project ID is provided
  const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID;
  if (clarityProjectId && clarityProjectId.trim() !== '') {
    clarityService.initialize(clarityProjectId);
  }

  // Enable API mocking in development if VITE_USE_MOCKS is set to 'true'
  if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS === 'true') {
    const { worker } = await import('./mocks/browser');

    await worker.start({
      onUnhandledRequest: 'bypass', // Don't warn about unhandled requests
    });

    console.log('🎭 Mock Service Worker enabled - Using mock data for API calls');
  }

  // Create root element
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  // Render app
  root.render(
    <React.StrictMode>
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </React.StrictMode>
  );
}

// Start the application
initializeApp();
